import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * T2411: tailwind-merge mora poznati imena tipografske lestvice (index.css,
 * `--text-*`). Brez tega bi `text-caption` štel za BARVO in
 * `cn('text-caption', 'text-[var(--bp-mute)]')` bi velikost tiho zavrgel.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display', 'title', 'heading', 'body', 'dense', 'caption'],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
